import React from 'react'
import { Grid } from '@mui/material'
import FormInput from 'components/FormInput'
import { Box } from '@mui/system'
import Label from 'components/Label'
import FormControlRadio from 'components/FormControlRadio'

// Área de interesse Cultural
export const culturalOptions = [
  { label: 'Cinema', value: 'CINEMA' },
  { label: 'Teatro', value: 'TEATRO' },
  { label: 'Exposições artísticas', value: 'EXPOSICOES_ARTISTICAS' },
  { label: 'Dança', value: 'DANCA' },
  { label: 'Ballet', value: 'BALLET' },
  { label: 'Shows', value: 'SHOWS' },
]

// Área de interesse Esporte
export const sportsOptions = [
  { label: 'Futebol', value: 'FUTEBOL' },
  { label: 'Basquete', value: 'BASQUETE' },
  { label: 'Vôlei', value: 'VOLEI' },
  { label: 'Natação', value: 'NATACAO' },
  { label: 'Box', value: 'BOX' },
  { label: 'Ginástica Olímpica', value: 'GINASTICA_OLIMPICA' },
  { label: 'Ginástica Rítmica', value: 'GINASTICA_RITMICA' },
  { label: 'Capoeira', value: 'CAPOEIRA' },
  { label: 'Artes Marciais', value: 'ARTES_MARCIAIS' },
  { label: 'Surf', value: 'SURF' },
  { label: 'Futevôlei', value: 'FUTEVOLEI' },
]

interface CultureSportsProps {
  control: any
  doNotHasEditPermission: boolean
}

const simNaoOptions = [
  {
    label: 'Sim',
    value: 'S',
  },
  {
    label: 'Não',
    value: 'N',
  },
]

const CultureSports: React.FC<CultureSportsProps> = ({ control, doNotHasEditPermission }) => {
  return (
    <Grid container item xs={12} spacing={2}>
      <Grid item md={12} xs={12}>
        <label>A - Espaços culturais acessados</label>
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item md={12} xs={12}>
          <FormControlRadio
            name='meioAbertoAcompInfoCulturaEsporte.areaInteresseCultura'
            label='Área de Interesse Cultural'
            control={control}
            options={culturalOptions}
            disabled={doNotHasEditPermission}
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item md={12} xs={12}>
          <FormControlRadio
            control={control}
            name='meioAbertoAcompInfoCulturaEsporte.possuiIdJovemParaAtividadesCulturais'
            label='B - Possui ID JOVEM para acesso as atividades culturais?'
            options={simNaoOptions}
            disabled={doNotHasEditPermission}
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item md={12} xs={12}>
          <label>C - Atividades esportivas acessadas</label>
        </Grid>
        <Grid item md={12} xs={12}>
          <FormControlRadio
            name='meioAbertoAcompInfoCulturaEsporte.areaInteresseEsporte'
            label='Área de Interesse Esporte'
            control={control}
            options={sportsOptions}
            disabled={doNotHasEditPermission}
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item md={12} xs={12}>
          <Box display={'flex'} flexDirection={'column'} gap={1}>
            <Label text={'Observações:'} sx={{ fontSize: 14, color: 'text.primary' }} />
            <FormInput
              name='meioAbertoAcompInfoCulturaEsporte.observacoes'
              control={control}
              multiline
              minRows={4}
              disabled={doNotHasEditPermission}
            />
          </Box>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CultureSports
